import { Component, HostBinding, Input } from '@angular/core';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Component({
    selector   : 'fuse-nav-horizontal-item',
    templateUrl: './item.component.html',
    styleUrls  : ['./item.component.scss']
})
export class FuseNavHorizontalItemComponent
{
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: any;

    constructor(
        private _fuseNavigationService: FuseNavigationService
    )
    {

    }

    onItemClick(): void
    {
        this._fuseNavigationService.onItemCollapsed.next(null);
    }
}
